import { render } from "./SliderNavigationButton.vue?vue&type=template&id=fcaf6738&scoped=true"
import script from "./SliderNavigationButton.vue?vue&type=script&lang=js"
export * from "./SliderNavigationButton.vue?vue&type=script&lang=js"

import "./SliderNavigationButton.vue?vue&type=style&index=0&id=fcaf6738&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcaf6738"]])

export default __exports__